import { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import { Form } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Select from 'react-select';
import { DeleteButton } from '../../../components/DeleteButton';

import { ButtonWithDisabledTooltip } from '../../../components/ButtonWithDisabledTooltip';

const maximumNumberOfUsers = 10;

class ModalContactGroupAddOrUpdateInternal extends Component {

    state = {
        groupId: "",
        name: "",
        description: "",
        updatedUsers: [],
        userOptions: [],
        selectedUserOption: null,
    }

    constructor(props) {
        super(props);

        // Build the description validation Regex.
        let nonPrintableCharStart = String.fromCharCode(0x00); // NULL char
        let nonPrintableCharEnd = String.fromCharCode(0x1F); // S7 char
        let delRegex = String.fromCharCode(0xF); // DEL char
        let backslashRegex = "\\\\"; // The parsing of the literal string will reduce this to 2 backslashes, the parsing of this string by the RegExp class will reduce it to a single literal backslash to be matched.
        let forwardslashRegex = "\\/"; 
        let bracketOpeningRegex = "\\["; 
        let bracketClosingRegex = "\\]"; 
        let quotationRegex = "\\\"";
        let additionalCharsRegex = "!@#$%^&*()={};:";

        this.nameValidationRegex = new RegExp(`^[^${nonPrintableCharStart}-${nonPrintableCharEnd}${delRegex}${backslashRegex}${forwardslashRegex}${bracketOpeningRegex}${bracketClosingRegex}${quotationRegex}]*$`);
        this.descriptionValidationRegex = new RegExp(`^[^${nonPrintableCharStart}-${nonPrintableCharEnd}${delRegex}${backslashRegex}${forwardslashRegex}${bracketOpeningRegex}${bracketClosingRegex}${quotationRegex}${additionalCharsRegex}]*$`);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.setInitialValues();
        }
    }

    setInitialValues = () => {
        const isUpdate = this.props.isUpdate;

        let updatedUsers = [];
        if (isUpdate) {
            this.props.contactGroupToUpdate.users.forEach(user => {
                updatedUsers.push(user);
            });
        }

        this.setState(
            {
                groupId: isUpdate ? this.props.contactGroupToUpdate.groupId : "",
                name: isUpdate ? this.props.contactGroupToUpdate.name : "",
                description: isUpdate ? this.props.contactGroupToUpdate.description : "",
                updatedUsers: updatedUsers,
            }
        );

        this.SetUserSelectState(updatedUsers);
    }

    SetUserSelectState = (currentUsers) =>{
        const availableUsers = this.getAvailableUsersExcept(currentUsers);

        var userOptions = [];
        var selectedUserOption = null;

        availableUsers.forEach(availableUser => {
            var userOption = {value:availableUser, label:availableUser.name};
            userOptions.push(userOption);

            if (!selectedUserOption)
            {
                selectedUserOption = userOption;
            }
        });

        this.setState(
            {
                userOptions: userOptions,
                selectedUserOption: selectedUserOption,
            }
        );
    }

    handleDoneButtonClicked = () => {
        const trimmedName = this.state.name.trim();
        const trimmedDescription = this.state.description.trim();

        const usersAdded = this.props.isUpdate ? 
            this.state.updatedUsers.filter(updatedUser => !this.props.contactGroupToUpdate.users.some(user => user.userId === updatedUser.userId)) :
            this.state.updatedUsers;
        const usersRemoved = this.props.isUpdate ? this.props.contactGroupToUpdate.users.filter(user => !this.state.updatedUsers.some(updatedUser => updatedUser.userId === user.userId)) : [];

        const doneInfo = {
            groupId: this.state.groupId,
            name: trimmedName,
            description: trimmedDescription,
            usersAdded: usersAdded,
            usersRemoved: usersRemoved,
            isUpdate: this.props.isUpdate
        }

        this.props.onAddOrUpdate(doneInfo);
    }

    handleCancelButtonClicked = () => {
        this.props.onHide();
    }

    handleNameChanged = (e) => {
        const updatedName = e.target.value;

        if (updatedName.length > 0 && !this.nameValidationRegex.test(updatedName)) {
            return;
        }
                
        this.setState({
            name: updatedName
        });
    }

    handleDescriptionChanged = (e) => {
        const updatedDescription = e.target.value;

        if (updatedDescription.length > 0 && !this.descriptionValidationRegex.test(updatedDescription)) {
            return;
        }
                
        this.setState({
            description: updatedDescription
        });
    }

    handleUserAdd = () => {
        if (!this.state.selectedUserOption) {
            return;
        }

        let updatedUsers = this.state.updatedUsers;
        if (updatedUsers.some(updatedUser => updatedUser.userId === this.state.selectedUserOption.value.userId)) {
            return;
        }

        updatedUsers.push(this.state.selectedUserOption.value);
        this.SetUserSelectState(updatedUsers);

        this.setState({
            updatedUsers: updatedUsers,
        });
    }

    handleUserDelete = (user) => {
        const updatedUsers = this.state.updatedUsers.filter(updatedUser => updatedUser.userId !== user.userId);
        this.SetUserSelectState(updatedUsers);

        this.setState({
            updatedUsers: updatedUsers,            
        });
    }

    handleSelectedUserChange = (selectedUserOption) => {
        if (!this.state.selectedUserOption || !selectedUserOption || this.state.selectedUserOption.value !== selectedUserOption.value) {
            this.setState(
                {
                    selectedUserOption: selectedUserOption
                }
            );
        }
    }

    shouldAddOrUpdateButtonBeEnabled = () => {
        return this.getAddOrUpdateButtonTooltip() === null;
    }

    getAddOrUpdateButtonTooltip = () => {
        if (!this.props.isOpen) {
            return null;
        }

        if (this.state.name === '') {
            return "Name may not be empty";
        }

        if (this.state.name.length > 50) {
            return "Name must be less than 50 characters";
        }

        if (this.state.description.length > 256) {
            return "Description must be less than 256 characters";
        }

        if (this.state.name !== this.props.contactGroupToUpdate.name ||
            this.state.description !== this.props.contactGroupToUpdate.description ||
            this.IsContactsDifferent()) {
                return null;
        }

        return "No changes detected";
    }

    IsContactsDifferent = () => {
        if (this.state.updatedUsers.length !== this.props.contactGroupToUpdate.users.length) {
            return true;
        }

        this.state.updatedUsers.forEach(updatedUser => {
            if (!this.props.contactGroupToUpdate.users.some(user => user.userId === updatedUser.userId)) {
                return true;
            }
        });

        return false;
    }

    shouldAddUserButtonBeEnabled = () => {
        return this.getAddUserButtonTooltip() === null;
    }

    getAddUserButtonTooltip = () => {
        if (!this.props.isOpen) {
            return null;
        }

        if (this.state.updatedUsers.length >= maximumNumberOfUsers) {
            return "Maximum number of users reached";
        }

        if (!this.state.selectedUserOption) {
            return "No more users to add";
        }

        return null;
    }

    getAvailableUsersExcept = (updatedUsers) => {
        const availableUsers = this.props.users.filter(user => !updatedUsers.some(updatedUser => updatedUser.userId === user.userId));

        return availableUsers;
    }

    render() {
        const headerText = this.props.isUpdate ? 'Update ContactGroup' : 'Add ContactGroup';
        const doneButtonText = this.props.isUpdate ? 'Update' : 'Add';

        return <Modal show={this.props.isOpen} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="mt-3" onSubmit={e => e.preventDefault()}>
                    <Form.Group controlId="newContactGroupName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter name" value={this.state.name} autoComplete="off" onChange={this.handleNameChanged} />
                    </Form.Group>
                    <Form.Group controlId="newContactGroupDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" placeholder="Enter description" value={this.state.description} autoComplete="off" onChange={this.handleDescriptionChanged} />
                    </Form.Group>
                    <h5>
                        Current Contacts
                    </h5>
                    <table className="table table-striped table-bordered my-4">
                        <thead className="thead-dark">
                            <tr key="modalContactsHeader">
                                <th scope="col">Name</th>
                                <th scope="col" width="70px">Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.updatedUsers.map((user) => {
                                return <tr key={user.userId}>
                                    <td className="align-middle">
                                        {user.name}
                                    </td>
                                    <td className="align-middle">
                                        <DeleteButton tooltip="Delete user" onClick={() => this.handleUserDelete(user)} />
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                    <Form.Group as={Row} controlId="newContactGroupUsers">
                        <Col sm="8">
                            <Select isSearchable={true} value={this.state.selectedUserOption} options={this.state.userOptions} onChange={this.handleSelectedUserChange} placeholder='No more users' />
                        </Col>    
                        <ButtonWithDisabledTooltip color='primary' size='sm' disabled={!this.shouldAddUserButtonBeEnabled()} disabledTooltip={this.getAddUserButtonTooltip()} onClick={this.handleUserAdd}>
                            Add user
                        </ButtonWithDisabledTooltip>                                                
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                <ButtonWithDisabledTooltip color="primary" disabled={!this.shouldAddOrUpdateButtonBeEnabled()} disabledTooltip={this.getAddOrUpdateButtonTooltip()} onClick={this.handleDoneButtonClicked}>{doneButtonText}</ButtonWithDisabledTooltip>{' '}
            </Modal.Footer>
        </Modal>;
    }
}

export const ModalContactGroupAddOrUpdate = (props) => {
    return (
        <ModalContactGroupAddOrUpdateInternal {...props}/>
    )
}